var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckedBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.25C2.25736 1.25 1.25 2.25736 1.25 3.5V16.5C1.25 17.7426 2.25736 18.75 3.5 18.75H16.5C17.7426 18.75 18.75 17.7426 18.75 16.5V3.5C18.75 2.25736 17.7426 1.25 16.5 1.25H3.5Z",
    stroke: "#B5B5B5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedBox);
export default __webpack_public_path__ + "static/media/unchecked-box.e4cc16ecc0c4fc6dfa2b53e324699a60.svg";
export { ForwardRef as ReactComponent };